import { useState } from "react";
import { MessageCircle } from "lucide-react";
import { useLanguage } from "@/i18n";
import { whatsappLink } from "@/constants/brand";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Ticker from "@/components/Ticker";
import Services from "@/components/Services";
import Security from "@/components/Security";
import Booking from "@/components/Booking";
import Footer from "@/components/Footer";

const FloatingWhatsApp = () => {
  const { lang } = useLanguage();
  const msg = lang === "pt"
    ? "Olá! Gostaria de agendar uma reunião online para falar sobre soluções em tecnologia."
    : "Hello! I would like to schedule an online meeting to discuss technology solutions.";
  return (
    <a
      data-testid="floating-whatsapp-button"
      href={whatsappLink(msg)}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="WhatsApp"
      className="fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-emerald-500 text-[#030706] shadow-[0_0_30px_rgba(16,185,129,0.5)] transition-transform duration-300 hover:scale-110"
    >
      <MessageCircle className="h-7 w-7" strokeWidth={2.2} />
    </a>
  );
};

export default function LandingPage() {
  const [preselectedService, setPreselectedService] = useState(null);

  return (
    <div className="min-h-screen overflow-x-clip bg-[#030706] text-slate-100">
      <Navbar />
      <main>
        <Hero />
        <Ticker />
        <Services onSelect={setPreselectedService} />
        <Security />
        <Booking preselectedService={preselectedService} />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}
